import { render } from "./batchUpdateStaffDialog.vue?vue&type=template&id=ff66a956&scoped=true"
import script from "./batchUpdateStaffDialog.vue?vue&type=script&lang=js"
export * from "./batchUpdateStaffDialog.vue?vue&type=script&lang=js"

import "./batchUpdateStaffDialog.vue?vue&type=style&index=0&id=ff66a956&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff66a956"]])

export default __exports__